import { computed, Signal, signal } from '@angular/core';
import { pick } from 'lodash';
import { Observable, startWith, Subject } from 'rxjs';
import { EFieldTypes, ISqcdpDate, TFilterSave } from 'scw-digital-boards-widgets';
import { DATE_FORMAT } from '../../../utilities/date-utilities.service';
import { IAdvancedFilterConfiguration, IFilterIdentity, TSelectedFilter } from './advanced-filter.interface';

export class AdvancedFilterManager {
  public isFilterCardVisible = false;
  public configuration = signal<IAdvancedFilterConfiguration[]>([]);
  public readonly appliedFilters = signal<TFilterSave[] | null>(null);
  public readonly unappliedFilters = signal<TSelectedFilter[]>([]);
  public readonly unappliedValidFilters = computed(() => {
    return this.unappliedFilters()
      .filter((existingFilter) => !('isInvalid' in existingFilter) || !existingFilter.isInvalid?.())
      .map((existingFilter) => pick(existingFilter, ['value', 'operator', 'field', 'idOfCustom']) as TFilterSave);
  });

  public readonly hoveredFilterIdentity = signal<IFilterIdentity | null>(null);
  public readonly sqcdpDate = signal<ISqcdpDate>(
    {
      setDate: null,
      fallbackDates: null,
    },
    {
      equal: (value1, value2) => {
        return (
          value1.setDate === value2.setDate &&
          value1.fallbackDates?.startDate?.format(DATE_FORMAT) ===
            value2.fallbackDates?.startDate?.format(DATE_FORMAT) &&
          value1.fallbackDates?.endDate?.format(DATE_FORMAT) === value2.fallbackDates?.endDate?.format(DATE_FORMAT)
        );
      },
    },
  );
  public readonly dateIsSetManuallySubject = new Subject<void>();

  constructor(
    initialConfiguration: IAdvancedFilterConfiguration[] = [],
    public readonly areDefaultValuesReady$: Observable<boolean> = new Observable<boolean>().pipe(startWith(true)),
    public readonly defaultValues: Signal<TFilterSave[]> = signal([]),
  ) {
    this.configuration.set(initialConfiguration);

    for (const configuration of initialConfiguration) {
      for (const identityConfiguration of configuration.configurations) {
        if (identityConfiguration.type === EFieldTypes.apiDropdown) {
          identityConfiguration.resource.appliedFilters = this.unappliedValidFilters;
        }
      }
    }
  }
}
